import { render, staticRenderFns } from "./CaseDetailsTable.vue?vue&type=template&id=dfcade04&"
import script from "./CaseDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CaseDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports